import React from 'react';
import { GlobalLogic } from '../../shared/logic/global-logic';
import { TestLogicFactory } from '../../eye-test/logic/test-logic-factory';
import { formatFloatingNumber } from '../../shared/util/functions';

export const ResultMichelsonTest: React.FunctionComponent = () => {
	const globalLogic = GlobalLogic.getInstance();
	const testLogic = TestLogicFactory.getInstanceOf('michelson-test-logic');
	const lastIdentified = testLogic.smallestCorrectLandolt;
	const lastIdentifiedReduced = testLogic.smallestCorrectLandoltReducedOpacity;
	const visus = lastIdentified.visusOneMeter * globalLogic.distance / 100;
	const resultDifference = Math.abs(lastIdentified.id - lastIdentifiedReduced.id);

	const additionalVisus = ((): JSX.Element => {
		if (visus > 1.25) {
			return <><br />Das ist eine <strong>ausgezeichnete</strong> Sehleistung!</>;
		}

		if (visus > 1) {
			return <><br />Das ist eine <strong>sehr gute</strong> Sehleistung!</>;
		}

		if (visus > 0.8) {
			return <><br />Das ist eine <strong>gute</strong> Sehleistung!</>;
		}

		return <><br />Ihre Sehleistung ist möglicherweise nicht optimal.</>;
	})();

	const additionalContrast = ((): JSX.Element => {
		if (resultDifference <= 3) {
			return <><br />Ihr Kontrastsehen ist <strong>nicht eingeschränkt</strong>.</>;
		}

		if (resultDifference <= 6) {
			return <><br />Ihr Kontrastsehen ist <strong>eingeschränkt</strong>.</>;
		}

		return <><br />Ihr Kontrastsehen ist <strong> stark eingeschränkt</strong>.</>;
	})();


	return (
		<>
			<p className={'standard-text'}>
				Sie haben einen <strong>Visus von ungefähr {formatFloatingNumber(visus)}.</strong>
				{additionalVisus}
			</p>
			<p className={'standard-text'}>
				Die Differenz in Ihrem Kontrastsehen beträgt <strong>{resultDifference} Stufen</strong>.
				{additionalContrast}
			</p>
			<p className={'standard-text'}>Bitte vereinbaren Sie einen <strong>kostenlosen Termin</strong> mit unserem Team.</p>
		</>
	);
};
